<template>
  <div class="actions-items__item">
    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <a v-bind="attrs" v-on="on">
          <span>{{ $t(`${namespace}.bulkActions`) }}</span><v-icon color="primary" small>keyboard_arrow_down</v-icon>
        </a>
      </template>

      <v-list>
        <v-list-item
          v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD')"
          @click="$router.push({ name: 'EmployeeBulkOperation' })"
        >
          <v-list-item-title>
            {{ $t(`${namespace}.addNewCollaboratorsBulk`) }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE')"
          @click="openSupervisorBulkUpdateDialog"
        >
          <v-list-item-title>
            {{ $t(`${namespace}.updateSupervisorBulk`) }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE')"
          @click="openSetWebCallPermissionBulkDialog"
        >
          <v-list-item-title>
            {{ $t(`${namespace}.webcallPermissionBulk`) }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE')"
          @click="openCategoryPermissionBulkDialog"
        >
          <v-list-item-title>
            {{ $t(`${namespace}.updateCategoriesBulk`) }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE')"
          @click="$router.push({ name: 'EmployeeMassCreditPolicy' })"
        >
          <v-list-item-title>
            {{ $t(`${namespace}.updateCreditPoliciesBulk`) }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="hasRole('company', 'ROLE_DELETE_COMPANY_COMPANYID_EMPLOYEES_MULTIDELETE')"
          @click="openExcludeEmployeesByIDDialog"
        >
          <v-list-item-title>
            {{ $t(`${namespace}.excludeEmployeesByID`) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <SupervisorBulkUpdateDialog
      :visible="supervisorBulkUpdateDialog"
      @close="closeSupervisorBulkUpdateDialog"
    />

    <SetWebCallPermissionBulkDialog
      :visible="setWebCallPermissionBulkDialog"
      @close="closeSetWebCallPermissionBulkDialog"
    />

    <CategoryPermissionBulkDialog
      :visible="categoryPermissionBulkDialog"
      @close="closeCategoryPermissionBulkDialog"
    />

    <ExcludeEmployeesByIDDialog
      :visible="excludeEmployeesByIDDialog"
      @close="closeExcludeEmployeesByIDDialog"
    />
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import SupervisorBulkUpdateDialog from 'components/pages/employees/dialogs/SupervisorBulkUpdate'
import SetWebCallPermissionBulkDialog from 'components/pages/employees/dialogs/SetWebCallPermissionBulk'
import CategoryPermissionBulkDialog from 'components/pages/employees/dialogs/CategoryPermissionBulk'
import ExcludeEmployeesByIDDialog from 'components/pages/employees/dialogs/ExcludeEmployeesByIDDialog'

export default {
  name: 'BulkActions',
  components: {
    SupervisorBulkUpdateDialog,
    SetWebCallPermissionBulkDialog,
    CategoryPermissionBulkDialog,
    ExcludeEmployeesByIDDialog
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage.table.actions',
      supervisorBulkUpdateDialog: false,
      setWebCallPermissionBulkDialog: false,
      categoryPermissionBulkDialog: false,
      excludeEmployeesByIDDialog: false
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    openSupervisorBulkUpdateDialog () {
      this.supervisorBulkUpdateDialog = true
    },

    closeSupervisorBulkUpdateDialog (reload) {
      this.supervisorBulkUpdateDialog = false
      reload && this.$emit('reloadData')
    },

    openSetWebCallPermissionBulkDialog () {
      this.setWebCallPermissionBulkDialog = true
    },

    closeSetWebCallPermissionBulkDialog (reload) {
      this.setWebCallPermissionBulkDialog = false
      reload && this.$emit('reloadData')
    },

    openCategoryPermissionBulkDialog () {
      this.categoryPermissionBulkDialog = true
    },

    closeCategoryPermissionBulkDialog (reload) {
      this.categoryPermissionBulkDialog = false
      reload && this.$emit('reloadData')
    },

    openExcludeEmployeesByIDDialog () {
      this.excludeEmployeesByIDDialog = true
    },

    closeExcludeEmployeesByIDDialog (reload) {
      this.excludeEmployeesByIDDialog = false
      reload && this.$emit('reloadData', reload)
    }
  }
}
</script>
